/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum OrganisationState {
  Preparation = 'Preparation',
  Ready = 'Ready',
  NoOrganisationContext = 'NoOrganisationContext'
}
